import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


const PATH_TO_SERVER_CONSTANTS_FILE: string = './assets/data/server.constants.json';
const PATH_TO_BUILD_CONSTANTS_FILE: string = './assets/data/build.constants.json';

//REFERENCE: https://juristr.com/blog/2018/01/ng-app-runtime-config/#runtime-configuration
@Injectable()
export class ServerConstantsService {
  //Class members
  public static serverConstants: any;
  public static buildConstants: any;

  constructor(private http: HttpClient) { }

  //Private methods
  loadConstants() {
    this.http.get(PATH_TO_BUILD_CONSTANTS_FILE)
      .toPromise()
      .then(data => {
        ServerConstantsService.buildConstants = data;
      });
    return this.http.get(PATH_TO_SERVER_CONSTANTS_FILE)
      .toPromise()
      .then(data => {
        ServerConstantsService.serverConstants = data;
      });
  }

  getConstants() {
    return ServerConstantsService.serverConstants;
  }
  getBuildConstants() {
    return ServerConstantsService.buildConstants;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/server-constants.service.ts